import React from "react";
import { useUsers } from "../../pages/specialty-assistant/data";
import { displayNameForUser } from "../../util";
import { CommentLink } from "./CommentLink";
import { splitMessage } from "./mentions";
import styles from "./CommentMessage.module.css";

type CommentMessageProps = {
  message: string;
};

// Renders a comment message, showing "@[Display Name](user_id)" mention
// tokens as highlighted names and URLs as links. Prefers the user's current
// display name over the one embedded in the token, so renames stay fresh.
export const CommentMessage: React.FC<CommentMessageProps> = ({ message }) => {
  const users = useUsers();
  return (
    <>
      {splitMessage(message).map((segment, index) => {
        switch (segment.kind) {
          case "mention":
            return (
              <span key={index} className={styles.mention}>
                @
                {displayNameForUser(
                  users.data?.all_company_users.find(
                    (user) => user.id === segment.userId
                  )
                ) ?? segment.name}
              </span>
            );
          case "link":
            return <CommentLink key={index} href={segment.href} />;
          case "text":
            return <React.Fragment key={index}>{segment.text}</React.Fragment>;
        }
      })}
    </>
  );
};
